import AccountCreation, { Social } from "@/components/signup/account-creation";
import { experiments, ExperimentView } from "@/utils/experiment";

export const LoggedOutJiraProductTourAccountCreation = () => (
    <AccountCreation
        Login={null}
        Social={
            <ExperimentView
                experiment={experiments.cfind4311JiraEliminateMicrosoftSignup}
                render={(value) => {
                    if (value) {
                        return <Social providers={{ google: "Google" }} />;
                    }
                    return (
                        <Social
                            providers={{
                                google: "Google",
                                microsoft: "Microsoft"
                            }}
                        />
                    );
                }}
            />
        }
    />
);
